/** Trigger haptic feedback if the device supports it. */
export function haptic(style: 'light' | 'medium' | 'heavy' = 'light') {
  if (!('vibrate' in navigator)) return

  const patterns: Record<string, number> = {
    light: 10,
    medium: 20,
    heavy: 40,
  }
  navigator.vibrate(patterns[style])
}
